import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

import CheckoutPage from "../CheckoutPage/";

const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.spacing(1),
  },
}));

// Modal de pagamento de uma fatura. Só fecha pelo X: um clique acidental fora
// da janela não pode descartar o QR Code que o cliente está pagando.
const SubscriptionModal = ({ open, onClose, Invoice, onPaid }) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      fullScreen={fullScreen}
      scroll="paper"
    >
      <DialogTitle disableTypography className={classes.title}>
        <Typography variant="h6">
          {Invoice ? `Pagamento da fatura #${Invoice.id}` : "Pagamento"}
        </Typography>
        <IconButton aria-label="Fechar" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <CheckoutPage Invoice={Invoice} onPaid={onPaid} />
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionModal;
